import InlineFaas from './InlineFaas'

export default InlineFaas
